import { render, staticRenderFns } from "./UsersNav.vue?vue&type=template&id=183799ba&"
import script from "./UsersNav.vue?vue&type=script&lang=js&"
export * from "./UsersNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports